<!-- 岗位列表页 -->
<template>
  <div class="wrapper -mb-[50px]">
    <!-- banner -->
    <!-- 校园招聘 -->
    <BannerJoinUs
      v-if="this.$route.query.recruit_catagory_id == 3"
      :to="recruitCate[1].url"
      :bg="recruitCate[1].pic"
      :status="recruitCate[1].status"
      color="#b15217"
    />
    <!-- 社会招聘 -->
    <BannerJoinUs v-else :to="recruitCate[0].url" :bg="recruitCate[0].pic" :status="recruitCate[0].status" />
  </div>
</template>

<script>
import BannerJoinUs from '@/components/BannerJoinUs.vue';

export default {
  name: 'PosView',
  components: {
    BannerJoinUs,
  },
  computed: {
    recruitCate() {
      return this.$store.state.recruitCate;
    },
  },
};
</script>

<style lang="scss" scoped></style>
